import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.isPlaying)?_c(VBtn,{attrs:{"color":"primary","fab":"","small":""},on:{"click":_vm.pause}},[_c(VIcon,[_vm._v("pause")])],1):_c(VBtn,{attrs:{"color":"primary","fab":"","small":"","loading":_vm.isLoading,"disabled":!_vm.isEnabled},on:{"click":_vm.play}},[_c(VIcon,[_vm._v("play")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }